import { Button, Row } from "antd";
import { usePermissions } from "../../../../../lib/hooks/usePermissions";
import { InfoCircleOutlined } from "@ant-design/icons";

type HeaderProps = {
  onAddClicked: () => void;
};

export const Header = ({ onAddClicked }: HeaderProps) => {
  const { hasAccess } = usePermissions();

  return (
    <Row className="d-block w-100">
      <Row className="w-100 justify-space-between customer-info-card align-center card-header">
        <h5 className="h h5">Portal Access</h5>
        {hasAccess("CustomersUsers", "Add") && (
          <Button shape="round" onClick={onAddClicked}>
            Add New
          </Button>
        )}
      </Row>
      <Row className="mt-6 mb-4 align-center">
        <InfoCircleOutlined className="mr-2 text-md title" />
        <p className="my-0 text-md title">
          Users can view all accounts where the customer is a primary buyer or
          seller. They can also see account details, including all emails sent
          to this customer through the system.
        </p>
      </Row>
    </Row>
  );
};
